import * as types from '../mutation-types';
import {Form} from 'vform';
import axios from 'axios';

const state = {
    form: new Form({
        name: ''
    }),
    create: false,
    edit: false,
    search: '',
    page: '',
    loading: false,
    currentpage: 5,
    permissions: [],
    permission_id: '',
    error: '',
};
const getters = {
    create: state => state.create,
    edit: state => state.edit,
    form: state => state.form,
    search: state => state.search,
    permissions: state => state.permissions,
    loading: state => state.loading,
    permission_id: state => state.permission_id,
    error: state => state.error,
};
const actions = {
    async fetchPermissions({commit}) {
        commit(types.PERMISSION_LOADING);
        const uri = `/api/permissions/`;
        await axios.get(uri).then((response) => {
            commit(types.PERMISSIONS, response.data)
            commit(types.PERMISSION_LOADING);
        }).catch((response) => {
            commit(types.PERMISSION_ERROR, response.data);
        });
    },
    createModal({commit}) {
        commit(types.PERMISSION_CLEAR);
        commit(types.PERMISSION_CREATE);
    },
    editModal({commit}, permission) {
        commit(types.PERMISSION_EDIT, permission);
        commit(types.PERMISSION_ID, permission);
    },
}

const mutations = {
    [types.PERMISSION_ID](state, permissions) {
        state.permission_id = permissions.id;
    },
    [types.PERMISSIONS](state, permissions) {
        state.permissions = permissions;
    },
    [types.PERMISSION_CLEAR](state) {
        state.form.clear();
        state.form.reset();
    },
    [types.PERMISSION_CREATE](state) {
        state.create = !state.create;
    },
    [types.PERMISSION_EDIT](state, permission) {
        state.edit = !state.edit;
        if (state.edit === true) {
            state.form.fill(permission);
        } else {
            state.form.clear();
            state.form.reset();
        }
    },
    [types.PERMISSION_PAGE](state, page) {
        state.page = page;
    },
    [types.PERMISSION_CURRENTPAGE](state, currentpage) {
        state.currentpage = currentpage;
    },
    [types.PERMISSION_SEARCH](state, search) {
        state.search = search;
    },
    [types.PERMISSION_LOADING](state) {
        state.loading = !state.loading;
    },
    [types.PERMISSION_ERROR](state, data) {
        state.error = data;
    }
}

export {
    state,
    getters,
    actions,
    mutations,
}
